import { createAction, props } from '@ngrx/store';
import { AccountsResponse } from '../../../api/models/admin/account.model';


export const getAccountsAction = createAction(
    '[Admin Accounts Page] Get Accounts list',
        props<{  searchString: string, pagination:any}>()
);

export const searchAccountsAction = createAction(
    '[Admin Accounts Page] Search Accounts list',
        props<{ searchString: string, pagination:any}>()
);

export const setAccountsAction = createAction(
    '[Admin Accounts Page] Set Accounts list',
    props<{ accounts: AccountsResponse, searchString: string}>()
);

export const setAccountsActionFail = createAction(
    '[Admin Accounts Page] Set Accounts list failed',
    props<{ error:any}>()
);

export const clearAccountsAction = createAction(
    '[Admin Accounts Page] Clear Accounts list'
);

export const clearAccountSearchStringAction = createAction(
    '[Admin Accounts Page] Clear Accounts SearchString'
);

export const accountsActionTypes = {
    getAccountsAction,
    searchAccountsAction,
    setAccountsAction,
    setAccountsActionFail,
    clearAccountsAction,
    clearAccountSearchStringAction
}

